export const environment = {
    production: true,
    url_base: '/server',
    url_login_base: '/server',
    title: 'Gestión de Alumnis CMAB',
    event_name: 'Alumnis CMAB',
    event_year: ''

};
